<template>
  <span>
    <b-button variant="mr-1 mb-1" size="sm" @click="handleShowModal" title="Switch Plan">
      <i class="fa-solid fa-arrow-right-arrow-left font-size-18 m-0"></i>
    </b-button>
    <b-modal
      v-model="showSwitchPlanModal"
      :title="cvtitleSwitchPlan"
      size="xl"
      no-close-on-backdrop
      no-close-on-esc
      @show="disableBodyScroll"
      @hidden="enableBodyScroll"
    >
      <div>
        <label><strong>{{ cvCurrentPlan }}</strong></label>
        <p>{{propCurrentPlan.pay_subs_id}} - ₹ {{propCurrentPlan.pay_amount}}</p>
      </div>
      <div>
        <label for="switchPlanDropdown"><strong>{{ cvSubscriptionPlan }}</strong></label>&nbsp;
        <label class="primary-color font-size-16">*</label>
        <multiselect
          v-model="selectedNewPlan"
          :options="cleanedPlanList"
          @input="choosedPlanError = null"
          label="label"
          track-by="id"
          placeholder="Select Payment Plan"
          class="mt-2"
        />
      </div>
      <label class="text-danger font-size-14 mt-1">{{ choosedPlanError }}</label>
      <template #modal-footer="">
        <b-button size="sm" @click="closeSwitchPlanModal">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button :disabled="isSwithching" size="sm" variant="primary" @click="payTransactionsEdit">
          <b-spinner v-if="isSwithching" small class="mr-1" label="Loading"></b-spinner>
          {{isSwithching ? "Saving..." : cvbtnModalSave}}
        </b-button>
      </template>
    </b-modal>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </span>
</template>
<script>
import multiselect from "vue-multiselect"
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan"
import { PayTransactionss } from "../../../FackApi/api/PayTransactions"

export default {
  name: "SwitchPlan",
  components: {
    multiselect
  },
  data () {
    return {
      showSwitchPlanModal: false,
      cvtitleSwitchPlan: "Switch Plan",
      cvbtnModalCancel: "Cancel",
      cvbtnModalSave: "Save",
      cvSubscriptionPlan: "Select New Plan",
      cvCurrentPlan: "Current Plan",
      cleanedPlanList: [],
      showToast: false,
      toastVariant: "default",
      toastTitle: "Switch Plan",
      toastMsg: "",
      selectedNewPlan: null,
      choosedPlanError: null,
      isSwithching: false
    }
  },
  props: {
    propCurrentPlan: {
      type: Object,
      required: true
    }
  },
  methods: {
    /**
     * handleShowModal
     */
    handleShowModal () {
      this.showSwitchPlanModal = true
      let subsPlanName = ""
      if (this.propCurrentPlan.pay_subs_id.toLowerCase().includes("gpath")) {
        subsPlanName = "gpaths"
      }
      else if (this.propCurrentPlan.pay_subs_id.toLowerCase().includes("testseries")) {
        subsPlanName = "testseries"
      }
      else if (this.propCurrentPlan.pay_subs_id.toLowerCase().includes("spcm")) {
        subsPlanName = "spcm"
      }
      else {
        this.showToast = true
        this.toastVariant = "warning"
        this.toastMsg = "Unable to determine subscription plan name from current plan ID."
        return
      }
      this.getPlanNames(subsPlanName)
    },
    /**
     * getPlanNames
     */
    async getPlanNames (subsPlanName) {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this, { subs_plan_name: subsPlanName })
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
          this.cleanedPlanList = this.planIdList.map(plan => ({
            id: plan.subs_plan_id,
            pdt_id: plan.pdt_id,
            label: `${plan.subs_plan_name} (${plan.subs_plan_id})`,
            subs_plan_price: plan.subs_plan_price,
            modified_on: plan.modified_on
          }))
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    },
    /**
     * closeSwitchPlanModal
    */
    closeSwitchPlanModal () {
      this.showSwitchPlanModal = false
      this.selectedNewPlan = null
      this.$emit("emitCloseSwitchPlanModal")
    },
    /**
     * disableBodyScroll
     * Disable body scroll when modal opens
     */
    disableBodyScroll () {
      document.body.style.overflow = "hidden"
    },
    /**
     * enableBodyScroll
     * Enable body scroll when modal closes
     */
    enableBodyScroll () {
      document.body.style.overflow = "auto"
    },
    /**
     * payTransactionsEdit
     */
    async payTransactionsEdit () {
      try {
        // getting subs_plan_price of current plan from pay_subscription_plan to get the updated plan price
        const currentPlan = this.cleanedPlanList.find(plan => plan.id === this.propCurrentPlan.pay_subs_id)
        const currentPlanPayAmount = currentPlan ? currentPlan.subs_plan_price : null

        if (!this.selectedNewPlan) {
          this.choosedPlanError = "Please select a new plan to switch."
          return
        }
        else if (this.selectedNewPlan.id === this.propCurrentPlan.pay_subs_id) {
          this.choosedPlanError = "Selected plan is the same as the current plan."
          return
        }
        else if (this.selectedNewPlan.subs_plan_price > currentPlanPayAmount) {
          this.choosedPlanError = "Upgrading to a higher plan is not allowed through this switch. Please contact support."
          return
        }
        else if (this.propCurrentPlan.pay_status_code !== "PGW_SUCCESS") {
          this.choosedPlanError = "You can only switch plans for a successful payment."
          return
        }

        this.choosedPlanError = null
        this.isSwithching = true
        const payload = {
          pay_order_id: this.propCurrentPlan.pay_order_id,
          pay_tid: this.propCurrentPlan.pay_tid,
          subs_start_date: this.propCurrentPlan.modified_on,
          gide_user_id: this.propCurrentPlan.user_id,
          pay_subs_id: this.propCurrentPlan.pay_subs_id,
          subs_plan_id: this.selectedNewPlan.id, // id of the new plan
          pay_amount: this.selectedNewPlan.subs_plan_price
        }
        let payTransactionsAddResp = await PayTransactionss.payTransactionsSubsPlanSwitch(this, payload)
        if (payTransactionsAddResp && payTransactionsAddResp.resp_status) {
          this.showToast = true
          this.toastVariant = "success"
          this.toastMsg = "Plan switched successfully."
          this.closeSwitchPlanModal()
        }
        else {
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Failed to switch plan."
        }
      }
      catch (err) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Exception occurred while switching plan."
        console.error("Exception occurred at payTransactionsEdit() and Exception:", err.message)
      }
      finally {
        this.isSwithching = false
      }
    }
  }
}
</script>
<style scoped>
</style>
